import * as Sentry from "@sentry/nextjs";

export const isPracujMobileTyPage = (pathname = "") => pathname.includes("ThankYouPageForPracujMobile");

export const checkIfPracujMobileExists = () => typeof MobileInterfaceJS !== "undefined";

export const checkIfGetMichiganTokenExists = () =>
    checkIfPracujMobileExists() && typeof MobileInterfaceJS?.getMichiganToken === "function";

export const checkIfOnApplicationSucceedExists = () =>
    checkIfPracujMobileExists() && typeof MobileInterfaceJS?.onApplicationSucceed === "function";

export const checkIfOnApplicationSucceedNoCVExists = () =>
    checkIfPracujMobileExists() && typeof MobileInterfaceJS?.onApplicationSucceedNoCV === "function";

export const getMichiganToken = () => {
    if (!checkIfGetMichiganTokenExists()) return null;
    return MobileInterfaceJS?.getMichiganToken?.() || null;
};

export const parseMichiganToken = (michiganToken: string): { token: string | null; userId: string | null } => {
    try {
        const { token, userId } = JSON.parse(michiganToken);
        return { token, userId };
    } catch (e) {
        return { token: null, userId: null };
    }
};

export const checkIfPracujMobileApplicationSucceedExists = () =>
    checkIfOnApplicationSucceedExists() || checkIfOnApplicationSucceedNoCVExists();

export const onApplicationSucceed = () => {
    MobileInterfaceJS?.onApplicationSucceed?.();
};

export const onApplicationSucceedNoCV = () => {
    MobileInterfaceJS?.onApplicationSucceedNoCV?.();
};

export const onPracujMobileApplicationSucceed = (withCv: boolean) => {
    try {
        if (withCv) onApplicationSucceed();
        else onApplicationSucceedNoCV();
    } catch (e) {
        Sentry.withScope((scope) => {
            scope.setTag("feature", "pracuj-mobile-application");
            scope.setContext("Extras", {
                withCv,
            });

            Sentry.captureException(e);
        });
    }
};
